import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../utils/cn';

interface FixLinkProps {
  /** Route to navigate to (the screen where the issue is resolved). */
  to: string;
  /** Optional override label. Defaults to the shared "Fix this →" string. */
  label?: string;
  className?: string;
  testId?: string;
}

/**
 * Shared "Fix this →" deep-link, mirroring the SIF preflight company-check style.
 * Lands HR on the exact screen (and exact employee, for per-employee issues)
 * where a compliance issue is resolved.
 */
export const FixLink: React.FC<FixLinkProps> = ({ to, label, className, testId }) => {
  const { t } = useTranslation();
  return (
    <Link
      to={to}
      data-testid={testId}
      className={cn('inline-flex items-center gap-1 text-xs text-blue-600 hover:underline', className)}
    >
      {label ?? t('payroll.complianceCenter.wps.fixThis', 'Fix this')}
      <ArrowRight className="w-3 h-3" />
    </Link>
  );
};

export default FixLink;
